import { useEffect, useState } from "react";

import { getFeesPreferencesByStateCode } from "../api";
import { isNotEmptyString } from "../utils";

export default function useFeePreferencesByState(stateCode, onError) {
  const [loading, setLoading] = useState(false);
  const [feePreferences, setFeePreferences] = useState(null);

  useEffect(() => {
    async function fetchPreferences() {
      try {
        const result = await getFeesPreferencesByStateCode(stateCode);
        setFeePreferences(result);
      } catch (err) {
        onError(err);
      }
      setLoading(false);
    }

    if (isNotEmptyString(stateCode)) {
      setLoading(true);
      fetchPreferences();
    }
  }, [stateCode, onError]);

  return [feePreferences, loading];
}
